export const providerInfo: Record<number, any> = {
    8: "https://www.netflix.com/",
    9: "https://www.amazon.com/Amazon-Video/b?ie=UTF8&node=2858778011",
    337: "https://www.disneyplus.com/", 
    2: "https://tv.apple.com/",  
    350: "https://tv.apple.com", 
    15: "https://www.hulu.com",
    384: "https://www.max.com/",
    1899: "https://www.max.com/",
    283: "https://www.crunchyroll.com", 
    386: "https://www.peacocktv.com",
    387: "https://www.peacocktv.com",
    3: "https://play.google.com",
    192: "https://youtube.com",
    531: "https://paramountplus.com",
    7: "https://vudu.com",
    358: "https://directv.com",
    157: "https://mylifetime.com",
    37: "https://sho.com",
    207: "https://therokuchannel.roku.com",
    269: "https://funimation.com",
    212: "https://hoopladigital.com",
    363: "https://tntdrama.com",
}
